export class CalendarOutlineEventRole {
    //netgen start
    outlineEventId = 0;
    roleId = 0;
    count = 0;
    id = 0;
    //netgen end
}
